import { render } from "./CambioDeContrasena.vue?vue&type=template&id=54a91c9f&scoped=true"
import script from "./CambioDeContrasena.vue?vue&type=script&lang=js"
export * from "./CambioDeContrasena.vue?vue&type=script&lang=js"

import "./CambioDeContrasena.vue?vue&type=style&index=0&id=54a91c9f&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a91c9f"]])

export default __exports__